import axios from 'axios';

export function createClientInvitation(payload) {
    return axios.post(`/partners/${payload.partnerId}/client-invitations`, payload);
}
